const onlyDistinctFiles = (files, moreFiles) => {
    if (moreFiles.length === 0)
        return files;
    const moreFilesIds = new Set(moreFiles.map((item) => item.id));
    const filteredFiles = files.filter((item) => !moreFilesIds.has(item.id));
    return [...filteredFiles, ...moreFiles];
};
export default onlyDistinctFiles;
